'use client';
import Refresh from '@mui/icons-material/Refresh';
import { Column, BodyMedium, HeadlineSmall } from '../../styles';
import { FilledButton } from '../buttons';
import { useTranslations } from 'next-intl';
import { BoxProps } from '@mui/material';
import { ManageSearch } from '@mui/icons-material';
import { useTheme } from '../../hooks';

interface Props extends BoxProps {
    reset?: () => void;
    title?: string;
    text?: string;
}
const NoResults = ({ reset, title, text, ...props }: Props) => {
    const t_filtering = useTranslations('filtering');
    const { colors } = useTheme();
    return (
        <Column {...props} sx={{ alignItems: 'center', ...props.sx }}>
            <Column sx={{ alignItems: 'center', textAlign: 'center' }} width={'50%'}>
                <ManageSearch sx={{ color: colors.secondaryDark, fontSize: 140 }} />
                <HeadlineSmall mt={4} mb={1}>
                    {title ?? t_filtering('no_results_title')}
                </HeadlineSmall>
                <BodyMedium>{text ?? t_filtering('no_results_description')}</BodyMedium>
                {!!reset && (
                    <FilledButton
                        icon={<Refresh />}
                        label={t_filtering('no_results_button')}
                        onClick={reset}
                        sx={{ mt: 2 }}
                        aria-label={t_filtering('no_results_button')}
                    />
                )}
            </Column>
        </Column>
    );
};
export { NoResults };
